var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{opacity:0.6;}.d{fill:none;stroke:#162d43;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 19,
    height: 19,
    transform: "translate(794 482.493)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-794 -482.493)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(794.812 482.812)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M21.979,22.5v3.884a1.942,1.942,0,0,1-1.942,1.942H6.442A1.942,1.942,0,0,1,4.5,26.384V22.5",
    transform: "translate(-4.5 -10.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M20.211,9.355,15.355,4.5,10.5,9.355",
    transform: "translate(-6.615 -3.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M18,4.5V16.153",
    transform: "translate(-9.26 -3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.7d4a99dcaefc202893f454f2744f7c72.svg";
export { ForwardRef as ReactComponent };